<template>
    <div class="flex gap-4 mt-6">
        <Button icon="pi pi-save" :disabled="canSave" @click.prevent="$emit('save')" :label="t('common.Save')" :loading="isLoading"/>
        <Button v-if="showCancel" severity="secondary" icon="pi pi-times" @click.prevent="$emit('cancel')" :label="t('common.Cancel')" text />
    </div>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n';
const { t } = useI18n({ useScope: 'global' });
defineProps({
    canSave: Boolean,
    isLoading:Boolean,
    showCancel:{
        type:Boolean,
        default: false
    }
})
defineEmits(['save', 'cancel'])
</script>